import { dataPaintBucketSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPaintBucketSolid = /*#__PURE__*/createIcon(dataPaintBucketSolid)
export default IconPaintBucketSolid
